import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-factor',
  templateUrl: './health-factor.component.html',
  styleUrls: ['./health-factor.component.scss']
})
export class HealthFactorComponent implements OnInit, OnChanges {
  @Input() value: number;
  percentage = 0;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.setValue(this.value);
  }

  private setValue(value: number) {
    value = value || 0;
    this.percentage = value > 3 ? 100 : value / 3 * 100;
  }
}
